export default __webpack_public_path__ + "d35c386e567a7359ee5a1bc004dd6f63.png";